/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".help-dialog{position:fixed;top:0;left:0;right:initial;bottom:initial;z-index:9900;visibility:visible;opacity:1;text-align:left;outline:0;border:1px solid green;border-radius:.25rem;width:510px}.help-p{margin-top:.25rem;margin-bottom:.25rem}"];
export { styles as styles };
